<div *ngIf="!loader" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
     aria-hidden="true">
    <div class="" role="document">
        <div class="modal-content" style="border: none !important;">
            <div class="modal-header py-0">
                <h2 class="modal-title" id="exampleModalLongTitle">{{modalTitle}}</h2>

            </div>
            <div class="modal-body p-0">
                <div class="container-fluid">
                    <div class="row mb-3">
                        <div cdkDropList *ngFor="let track of tracks"
                             [id]="track.id"
                             [cdkDropListData]="track.columns"
                             [cdkDropListConnectedTo]="trackIds" (cdkDropListDropped)="onTalkDrop($event)"
                             class="row mt-3 col-12 col-sm-12 col-md-12 col-lg-12 col-lg-12 pr-0 pointer"
                        >
                            <div class="ss-header "
                                 [ngClass]="{'ss-background-todo': track.id=='todo',
                                 'ss-background-inprogress': track.id=='inprogress',
                                 'ss-background-ddone': track.id=='ddone'
                                 }">{{track.title}}</div>
                            <div cdkDrag
                                 class="mt-1 d-flex align-items-center col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-sm-3 pr-md-3 ss-status-badge"
                                 *ngFor="let column of track.columns">
                                <label class="mb-0">{{column.title}}</label>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button (click)="closeModal()" type="button" class="btn btn-light" data-dismiss="modal">Zatvori
                    </button>
                    <button (click)="saveChanges()" type="button" class="btn btn-primary">Sačuvaj</button>
                </div>
            </div>
        </div>
    </div>
</div>
